import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-twitter",
  imports: [],
  templateUrl: "./icon-twitter.component.html",
  styleUrl: "./icon-twitter.component.scss",
})
export class IconTwitterComponent {
  @Input() color: string = "#373737";
}
